import React, { useState } from 'react';
import { format } from 'date-fns';
import {
  ModalFormSection,
  ModalV2,
  ModalFooter,
} from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { InputFieldV2 } from 'components/common/form-controls';

const AvailabilityExportUTRModal = ({
  isOpen,
  isLoading,
  onClose,
  onExportFile,
}) => {
  // In BE, default start date is first day of current month, default end date is today
  // In FE, we set those as initial values for better UX, if cleared, BE will still use its defaults
  const [dateRange, setDateRange] = useState(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return [format(firstDayOfMonth, 'yyyy-MM-dd'), format(today, 'yyyy-MM-dd')];
  });

  const handleChange = (newRange) => {
    setDateRange(newRange);
  };

  const handleExportFile = async () => {
    await onExportFile(dateRange);
    onClose();
  };

  return (
    <ModalV2
      id="export-utr-modal"
      title="Export UTR (Utilization Rate)"
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      maxWidth="sm"
    >
      <ModalFormSection>
        <InputFieldV2
          type="dateRangePicker"
          name="dateRange"
          value={dateRange}
          onChange={handleChange}
          startText="Start Date"
          endText="End Date"
        />
      </ModalFormSection>
      <ModalFooter>
        <ButtonV2 disabled={isLoading} onClick={handleExportFile}>
          Export
        </ButtonV2>
      </ModalFooter>
    </ModalV2>
  );
};

export default AvailabilityExportUTRModal;
